// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    .multi-select-container {
      position: relative;
      width: 100%;
      font-family: inherit;
    }

    .select-input {
      min-height: 40px;
      padding: 4px 8px;
      border: 1px solid #D9D9D9;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      background: white;
      transition: all 0.2s;
      color: #2E005D;
    }

    .select-input:hover:not(.disabled) {
      border-color: #7323A8;
    }

    .select-input.focused {
      border-color: #7323A8;
      box-shadow: 0 0 0 2px rgba(115, 35, 168, 0.2);
    }

    .select-input.disabled {
      background: #F8F8F8;
      cursor: not-allowed;
    }

    .selected-items {
      display: flex;
      flex-wrap: wrap;
      gap: 4px;
      flex: 1;
      min-height: 24px;
      color: #2E005D;
    }

    .selected-items.has-items {
      padding: 2px 0;
    }

    .selected-tag {
      background: #F8F8F8;
      padding: 2px 8px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 0.875rem;
      border: 1px solid #D9D9D9;
      color: #2E005D;
    }

    .remove-tag {
      background: none;
      border: none;
      padding: 0;
      cursor: pointer;
      display: flex;
      align-items: center;
      color: #6C757D;
    }

    .remove-tag:hover:not(:disabled) {
      color: #E50085;
    }

    .remove-tag:disabled {
      cursor: not-allowed;
      opacity: 0.5;
    }

    .search-input {
      position: absolute;
      top: 100%;
      left: 0;
      right: 0;
      padding: 8px;
      border-top: none;
      border-radius: 0 0 4px 4px;
      width: 100%;
      display: none;
      z-index: 1000;
      background: white;
      color: #2E005D;
    }

    .search-input.visible {
      display: block;
    }

    .search-input::placeholder {
      color: #6C757D;
    }

    .dropdown-menu {
      position: absolute;
      top: calc(100% + 36px);
      left: 0;
      right: 0;
      max-height: 200px;
      overflow-y: auto;
      background: white;
      border: 1px solid #D9D9D9;
      border-top: none;
      border-radius: 0 0 4px 4px;
      display: none;
      z-index: 1000;
    }

    .dropdown-menu.show {
      display: block;
    }

    .dropdown-item {
      padding: 8px;
      cursor: pointer;
      transition: all 0.2s;
      color: #2E005D;
    }

    .dropdown-item:hover {
      background: #F8F8F8;
    }

    .dropdown-item.selected {
      background: #FFE5DD;
      color: #2E005D;
    }

    .no-results {
      padding: 8px;
      color: #6C757D;
      text-align: center;
    }

    .icon-sm {
      display: flex;
      align-items: center;
      color: #6C757D;
    }
  `, "",{"version":3,"sources":["webpack://./libs/ui/src/lib/components/elements/zikata-multi-select/zikata-multi-select.component.ts"],"names":[],"mappings":";IACI;MACE,kBAAkB;MAClB,WAAW;MACX,oBAAoB;IACtB;;IAEA;MACE,gBAAgB;MAChB,gBAAgB;MAChB,yBAAyB;MACzB,kBAAkB;MAClB,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,eAAe;MACf,iBAAiB;MACjB,oBAAoB;MACpB,cAAc;IAChB;;IAEA;MACE,qBAAqB;IACvB;;IAEA;MACE,qBAAqB;MACrB,6CAA6C;IAC/C;;IAEA;MACE,mBAAmB;MACnB,mBAAmB;IACrB;;IAEA;MACE,aAAa;MACb,eAAe;MACf,QAAQ;MACR,OAAO;MACP,gBAAgB;MAChB,cAAc;IAChB;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,mBAAmB;MACnB,gBAAgB;MAChB,kBAAkB;MAClB,aAAa;MACb,mBAAmB;MACnB,QAAQ;MACR,mBAAmB;MACnB,yBAAyB;MACzB,cAAc;IAChB;;IAEA;MACE,gBAAgB;MAChB,YAAY;MACZ,UAAU;MACV,eAAe;MACf,aAAa;MACb,mBAAmB;MACnB,cAAc;IAChB;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,mBAAmB;MACnB,YAAY;IACd;;IAEA;MACE,kBAAkB;MAClB,SAAS;MACT,OAAO;MACP,QAAQ;MACR,YAAY;MACZ,gBAAgB;MAChB,0BAA0B;MAC1B,WAAW;MACX,aAAa;MACb,aAAa;MACb,iBAAiB;MACjB,cAAc;IAChB;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,kBAAkB;MAClB,sBAAsB;MACtB,OAAO;MACP,QAAQ;MACR,iBAAiB;MACjB,gBAAgB;MAChB,iBAAiB;MACjB,yBAAyB;MACzB,gBAAgB;MAChB,0BAA0B;MAC1B,aAAa;MACb,aAAa;IACf;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,YAAY;MACZ,eAAe;MACf,oBAAoB;MACpB,cAAc;IAChB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,mBAAmB;MACnB,cAAc;IAChB;;IAEA;MACE,YAAY;MACZ,cAAc;MACd,kBAAkB;IACpB;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,cAAc;IAChB","sourcesContent":["\n    .multi-select-container {\n      position: relative;\n      width: 100%;\n      font-family: inherit;\n    }\n\n    .select-input {\n      min-height: 40px;\n      padding: 4px 8px;\n      border: 1px solid #D9D9D9;\n      border-radius: 4px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      cursor: pointer;\n      background: white;\n      transition: all 0.2s;\n      color: #2E005D;\n    }\n\n    .select-input:hover:not(.disabled) {\n      border-color: #7323A8;\n    }\n\n    .select-input.focused {\n      border-color: #7323A8;\n      box-shadow: 0 0 0 2px rgba(115, 35, 168, 0.2);\n    }\n\n    .select-input.disabled {\n      background: #F8F8F8;\n      cursor: not-allowed;\n    }\n\n    .selected-items {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 4px;\n      flex: 1;\n      min-height: 24px;\n      color: #2E005D;\n    }\n\n    .selected-items.has-items {\n      padding: 2px 0;\n    }\n\n    .selected-tag {\n      background: #F8F8F8;\n      padding: 2px 8px;\n      border-radius: 4px;\n      display: flex;\n      align-items: center;\n      gap: 4px;\n      font-size: 0.875rem;\n      border: 1px solid #D9D9D9;\n      color: #2E005D;\n    }\n\n    .remove-tag {\n      background: none;\n      border: none;\n      padding: 0;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      color: #6C757D;\n    }\n\n    .remove-tag:hover:not(:disabled) {\n      color: #E50085;\n    }\n\n    .remove-tag:disabled {\n      cursor: not-allowed;\n      opacity: 0.5;\n    }\n\n    .search-input {\n      position: absolute;\n      top: 100%;\n      left: 0;\n      right: 0;\n      padding: 8px;\n      border-top: none;\n      border-radius: 0 0 4px 4px;\n      width: 100%;\n      display: none;\n      z-index: 1000;\n      background: white;\n      color: #2E005D;\n    }\n\n    .search-input.visible {\n      display: block;\n    }\n\n    .search-input::placeholder {\n      color: #6C757D;\n    }\n\n    .dropdown-menu {\n      position: absolute;\n      top: calc(100% + 36px);\n      left: 0;\n      right: 0;\n      max-height: 200px;\n      overflow-y: auto;\n      background: white;\n      border: 1px solid #D9D9D9;\n      border-top: none;\n      border-radius: 0 0 4px 4px;\n      display: none;\n      z-index: 1000;\n    }\n\n    .dropdown-menu.show {\n      display: block;\n    }\n\n    .dropdown-item {\n      padding: 8px;\n      cursor: pointer;\n      transition: all 0.2s;\n      color: #2E005D;\n    }\n\n    .dropdown-item:hover {\n      background: #F8F8F8;\n    }\n\n    .dropdown-item.selected {\n      background: #FFE5DD;\n      color: #2E005D;\n    }\n\n    .no-results {\n      padding: 8px;\n      color: #6C757D;\n      text-align: center;\n    }\n\n    .icon-sm {\n      display: flex;\n      align-items: center;\n      color: #6C757D;\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
